import React from 'react'
import './LoadingSpinner.scss'

const spinnerImage = require('../../../../../assets/studentPreChecks/static_spinner.png');


export default function LoadingSpinner({ show }) {


    return (
        <div>
            { show &&
                <div className="loadingSpinner">
                    <img
                    alt="Processing Animation"
                    className="spinnerImage"
                    src={spinnerImage}
                    />
                </div>
            }
        </div>
    )
}
